import { EligibleRegisterSessionEnum } from '@schooly/api';

import {
  isSessionScope,
  isSessionTab,
  RegisterScope,
  RegisterSession,
  RegisterTab,
} from '../types';

const SESSION_MESSAGE_IDS = {
  [EligibleRegisterSessionEnum.Am]: 'attendance-AM',
  [EligibleRegisterSessionEnum.Pm]: 'attendance-PM',
} as const satisfies Record<RegisterSession, string>;

export const getSessionMessageId = (session: RegisterSession) => SESSION_MESSAGE_IDS[session];

export const getRegisterTabMessageId = (tab: RegisterTab) =>
  isSessionTab(tab) ? getSessionMessageId(tab) : 'attendance-PerPeriod';

type ScopeLabelParams = {
  scope: RegisterScope;
  periodName?: string;
  formatMessage: (descriptor: { id: string }) => string;
};

export const getScopeLabel = ({ scope, periodName, formatMessage }: ScopeLabelParams): string =>
  isSessionScope(scope)
    ? formatMessage({ id: getSessionMessageId(scope.session) })
    : (periodName ?? '');

export const getPeriodLabel = (
  period: { name: string; register_session: RegisterSession | null },
  formatMessage: ScopeLabelParams['formatMessage'],
): string => {
  if (!period.register_session) return period.name;

  const session = formatMessage({ id: getSessionMessageId(period.register_session) });

  return `${session}/${period.name}`;
};

export const getPeriodOrderLabel = (
  period: { order: number; register_session: RegisterSession | null },
  formatMessage: ScopeLabelParams['formatMessage'],
): string => {
  if (!period.register_session) return String(period.order);

  const session = formatMessage({ id: getSessionMessageId(period.register_session) });

  return `${session}/${period.order}`;
};
